// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"c4fd7233","689":"c4fd7233"}[chunkId] + ".chunk.css";
};